import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=0ac43376&"
import script from "./AdminFooter.vue?vue&type=script&lang=js&"
export * from "./AdminFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports